export default __webpack_public_path__ + "291a5478508c686f10001bcc52d977e2.png";